/**
 * Material Symbols icon (doc 147 §8.10).
 *
 * Renders a Material Symbols Rounded ligature. Decorative icons are
 * `aria-hidden`; pass a `label` to make an icon informative.
 */
import type { CSSProperties } from 'react';

export type IconSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export interface IconProps {
  /** Material Symbols ligature name, e.g. `hub`, `search`. */
  name: string;
  size?: IconSize;
  /** When set, the icon is informative and gets this aria-label. */
  label?: string;
  /** Override colour; defaults to `currentColor`. */
  color?: string;
  className?: string;
}

export function Icon({ name, size = 'sm', label, color, className }: IconProps): React.JSX.Element {
  const style: CSSProperties = {
    fontSize: `var(--icon-${size})`,
    ...(color ? { color } : {}),
  };
  return (
    <span
      className={`material-symbols-rounded${className ? ` ${className}` : ''}`}
      style={style}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
    >
      {name}
    </span>
  );
}
